import { useState, useEffect } from 'react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { PersonsV3 } from '@frontend/api-person';
import { useAppScopeStore } from '@frontend/scope';

export const useGetPatient = (personId?: string) => {
  const [person, setPerson] = useState<Person | null>(null);
  const { selectedLocationIds } = useAppScopeStore();

  const { data, isLoading } = PersonsV3.PersonQueries.useGetPersonLegacyQuery(
    { locationIds: selectedLocationIds, personId: personId ?? '' },
    { enabled: !!personId }
  );

  useEffect(() => {
    if (data) {
      setPerson(data);
    }
  }, [data]);

  return { isLoading, patient: person };
};
